import React, { useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { toast } from "sonner";
import {
  Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle,
} from "../ui/dialog";
import { Button } from "../ui/button";
import { Download, Link2 } from "lucide-react";

/** QR code del link pubblico Discovery: anteprima + download PNG 1024px (stampa). */
export const QrDialog = ({ assessment, onClose }) => {
  const wrapRef = useRef(null);
  if (!assessment) return null;
  const url = `${window.location.origin}/d/${assessment.slug_token}`;

  const download = () => {
    const canvas = wrapRef.current?.querySelector("canvas");
    if (!canvas) return;
    const el = document.createElement("a");
    el.href = canvas.toDataURL("image/png");
    el.download = `qr-${assessment.title.slice(0, 30).replace(/\s+/g, "_")}.png`;
    el.click();
    toast.success("QR code scaricato (PNG 1024px)");
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="rounded-xl bg-surface sm:max-w-sm" data-testid="discovery-qr-dialog">
        <DialogHeader>
          <DialogTitle>QR code — {assessment.title}</DialogTitle>
          <DialogDescription>
            Chi lo inquadra apre subito il questionario. Perfetto per biglietti, slide e locandine.
          </DialogDescription>
        </DialogHeader>
        <div ref={wrapRef} className="flex justify-center bg-white rounded-lg border border-border p-5" data-testid="discovery-qr-canvas">
          <QRCodeCanvas value={url} size={1024} marginSize={2} style={{ width: 208, height: 208 }} />
        </div>
        <div className="bg-subtle border border-border rounded-lg px-3 py-2 font-mono text-[11px] break-all text-text-secondary" data-testid="discovery-qr-link">
          {url}
        </div>
        <div className="flex gap-2">
          <Button onClick={download} data-testid="discovery-qr-download"
                  className="bg-accent hover:bg-accent-strong text-white flex-1 rounded-md">
            <Download size={14} className="mr-1.5" /> Scarica PNG
          </Button>
          <Button variant="outline" className="rounded-md" data-testid="discovery-qr-copy"
                  onClick={() => { navigator.clipboard.writeText(url); toast.success("Link copiato"); }}>
            <Link2 size={14} className="mr-1.5" /> Copia link
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
